export const guides_data = [
    {
        title: "registration",
        description: "",
        video: "",
    },
];